import React from "react";
import { useHistory } from "react-router";
import { useMutation, useQuery } from "react-query";

import Alert from "../alert/Alert";
import { StoreContext } from "app/context/Store";
import Button from "app/components/button/Button";
import SetReminder from "app/pages/set-reminder/SetReminder";
//import EnableAutoPay from "app/pages/enableautopay/EnableAutoPay";
import SwitchButton from "app/components/switchbutton/SwitchButton";
import { useGet, usePost } from "app/services/http-service";
import {
  CREATE_MOBILE_PREPAID_BILL,
  CREATE_SI,
  PAYU_URL,
  PREPARE_PAYMENT,
  PROFILE,
  PAYMENT_SUCCESS_URL,
  PAYMENT_FAILURE_URL,
  PAYMENT_CANCEL_URL,
  ADD_SHORT_NAME
} from "app/api/ApiEndpoints";
import useAlertConfig from "app/hooks/useAlertConfig";
import qs from "query-string";
import { Initial } from "react-initial";
import { getEncryptedString } from "../../utils/securityUtil";
import { getCustomerParamsMobilePrepaid } from "app/utils/MobileRechargeUtil";

const additionalParams = {
  agentTxnID: "PU0689231",
};
const sUrl = PAYMENT_SUCCESS_URL;

const fUrl = PAYMENT_FAILURE_URL;

const cUrl = PAYMENT_CANCEL_URL;

function RechargeSummary(props) {
  const { alertConfig, showFailureAlert } = useAlertConfig(6);
  const history = useHistory();
  const nickName = React.useRef();
  const submitButton = React.useRef();
  const { rechargePlanDetailsData } = props;
  const context = React.useContext(StoreContext);
  const authToken = localStorage.getItem("tspAuthToken");
  const {mno} = qs.parse(location.search);
  //const [autoPay, setAutoPay] = React.useState(false);
  const [reminder, setReminder] = React.useState(false);
  const [billDetails, setBillDetails] = React.useState(null);
  const [prePaymentData, setPrePaymentData] = React.useState(null);
  const [saveButtonVisible, setSaveButtonVisible] = React.useState(false);
  const [isAddToMyBillsChecked, setIsAddToMyBillsChecked] = React.useState(false);
  const [isInVaildShortName, setIsInVaildShortName] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  let isRedirectToHomePage = false;

  const { mutate: updateNickName } = useMutation((data) => usePost(data), {
    onSuccess: () => {
      if(isRedirectToHomePage){
        isRedirectToHomePage = false;
        setTimeout(()=>{
          history.push("/home");
        },[1000]);
      }
    }
  });

  React.useEffect(() => {
    if (prePaymentData) {
      submitButton.current.click();
    }
  }, [prePaymentData]);

  const linkItem = context?.state?.clientConfigData?.clientConfigs.find(
    (c) => c.name === "CUSTOM_PAYMENT_URL",
  );
  const webChannelName = context.state?.clientConfigData?.clientConfigs?.find(
    (c) => c.name === "web_initiating_channel",
  )?.value;
  const customPaymentLink = linkItem ? linkItem.value : "";
  // const customPaymentProps = ["txnid", "txndate", "productinfo"];

  function handleSwitchButtonChange(event) {
    const value = event.target.value === "false" ? false : true;
    const name = event.target.name;
    if (name === "autoPay") {
      setAutoPay(value);
    } else {
      setReminder(value);
    }
  }

  const [billErrorDetails, setBillErrorDetails] = React.useState(null);

  const { mutate: createBill } = useMutation((data) => usePost(data), {
    onSuccess: (data) => {
      setBillDetails(data);
    },
    onError: (data) => {
      setBillErrorDetails(data);
    },
  });

  React.useEffect(() => {
    if (rechargePlanDetailsData) {
      let customerParams = getCustomerParamsMobilePrepaid(rechargePlanDetailsData, mno);

      createBill({
        url: CREATE_MOBILE_PREPAID_BILL,
        token: authToken,
        data: {
          customerPhoneNumber: mno,
          customerParams: customerParams,
          amount: rechargePlanDetailsData?.price,
          // accountHolderName: "some Name",
          billDue: true,
          autoPay: false,
          enableReminder: false,
          operatorId: rechargePlanDetailsData?.operatorId,
        },
      });
    }
  }, [rechargePlanDetailsData]);

  function enrichPayloadData(data) {
    const payload = data?.data;
    const validationKey = [payload?.billerId, payload?.amount, payload?.userDetails?.firstName].join("|");
    const encryptedKey = getEncryptedString(validationKey);
    data['customHeaders'] = {
      verificationKey: encryptedKey
    };
    return data;
  }

  const { mutate: sendPrePaymentInfo } = useMutation((data) => usePost(enrichPayloadData(data)), {
    onSuccess: (data) => {
      setPrePaymentData(data);
      setTimeout(() => setIsLoading(false), 2000);
    },
    onError: (error) => {
      showFailureAlert(error?.message ? error?.message : "Something went wrong");
      setIsLoading(false);
    }
  });

  const { isSuccess: userLoaded } = useQuery(
    "fetchProfile",
    () => useGet({ url: PROFILE, token: authToken }),
    {
      onSuccess: (data) => {
        let user = {
          firstName: data.firstName ? data.firstName : "A User",
          phone: data.phone ? data.phone : "8789878542",
          email: data.email,
          lastName: data.lastName ? data.lastName : "test",
          userId: 1,
        };
        setUserDetails(user);
      }
    },
  );

  let [userDetails, setUserDetails] = React.useState({
    firstName: context?.state?.profileData?.firstName,
    phone: "8789878542",
    email: context?.state?.profileData?.email,
    lastName: context?.state?.profileData?.lastName
      ? context?.state?.profileData?.lastName
      : "test",
    userId: 1,
  });

  function getPaymentData() {
    const payload =  {
      additionalParams,
      userDetails,
      sUrl,
      fUrl,
      cUrl,
      productInfo: billDetails?.billerName,
      amount: rechargePlanDetailsData?.price,
      billerId: billDetails?.billerPayuId,
      deviceDetails: { MAC: "mac", IP: "ip", INITIATING_CHANNEL: webChannelName ? webChannelName : 'INT' },
      // Time being passing first item
      customerParams: billDetails?.customerParams[0]
        ? billDetails?.customerParams[0]
        : {},
      billId: billDetails?.id,
    };

    if (customPaymentLink !== "") {
      payload.encDhanData = localStorage.getItem("encDhanData");
    }

    return payload;
  }

  function getSIDetails() {
    return {
      maxLimitAmount: context?.billState?.autoPayDetails?.maxLimitAmount,
      pgType: "custom",
      preferredPaymentMode:
        context?.billState?.autoPayDetails?.preferredPaymentMode,
      billId: billDetails?.id,
    };
  }

  function preparePayment() {
    if(saveButtonVisible && !isInVaildShortName){
      updateNickName({
        url: `${ADD_SHORT_NAME}${billDetails?.id}/link?billNickName=${nickName.current.value}`,
        token: authToken,
        data: {
        }
      });
      setSaveButtonVisible(false);
    }
    if (!userLoaded) {
      setIsLoading(false);
      return;
    }
    const siData = {
      paymentDetails: getPaymentData(),
      standingInstruction: getSIDetails(),
    };

    const billState = context?.billStateValue();
    if (billState?.autoPayEnabled && billState?.intialAutoPayDetails && billState.autoPayDetails?.id) {
      upDateStandingInstruction({
        url: CREATE_SI + billState.autoPayDetails?.id,
        token: authToken,
        data: siData,
      });
    } else {
      const url = billState.autoPayEnabled ? CREATE_SI : PREPARE_PAYMENT;

      const apiMethod = billState.autoPayEnabled
        ? saveStandingInstructions
        : sendPrePaymentInfo;
      if (userDetails) {
        const preparePaymentInfo = {
          url: url,
          token: authToken,
          data: billState.autoPayEnabled ? siData : getPaymentData(),
        };
        apiMethod(preparePaymentInfo);
      }
    }
  }

  return (
    <>
      {alertConfig && (
        <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
      )}
      {
        billDetails && <>
        <div className="d-flex align-items-center pb-2 brand-head">
            {
              billDetails?.billerLogoURL ? (
                <div className="default_circle border-primary align-self-center">
                  <img src={billDetails?.billerLogoURL} alt="payulogo" width="20" />
                </div>
              ) : (
                <div className="initial-circle cursor-default">
                  <Initial name={billDetails?.billerName} charCount={2} fontSize={16} fontWeight={600} height={45} width={45} />
                </div>
              )
            }
        
        <div className="brand-name">
          <h2 className="font-weight-bold darkgrey">
            {rechargePlanDetailsData?.operatorName}
          </h2>
        </div>
      </div>
      <div className=" d-flex justify-content-end">
        <div className="form-check">
          <input className="form-check-input" type="checkbox" checked={isAddToMyBillsChecked} onChange={() => { setIsAddToMyBillsChecked(!isAddToMyBillsChecked); }} />
          <label className="form-check-label">Add to My Bills</label>
        </div>
      </div>
      <div className="info-group d-flex justify-content-between">
        <div className="border-bottom-primary">
          <label>Contact Number</label>
          <p className="font-weight-bold">{mno}</p>
        </div>
          {
            isAddToMyBillsChecked && (
              <div className=" col-md-6">
                <label>Short Name</label>
                <input
                  required
                  type="text"
                  ref={nickName}
                  className="form-control"
                  placeholder="Enter Short Name"
                  value={rechargePlanDetailsData?.billNickName}
                  onChange={(event) =>{
                    if (event.target.value) {
                      if (/[^a-zA-Z0-9]/.test(event.target.value)) {
                        setIsInVaildShortName(true);
                      }
                      else {
                        setIsInVaildShortName(false);
                      }
                    }
                    event.target.value === ""
                      ? setSaveButtonVisible(false)
                      : setSaveButtonVisible(true);
                  }
                  }
                />
                {
                  isInVaildShortName && (
                    <p style={{color : 'red'}}>Invaild Short Name</p>
                  )
                }
              </div>
            )
          }
      </div>
      <div className="card bg-info p-2">
        <div className="d-flex justify-content-between align-item-flex-start  summary-card grid-3">
          {
            rechargePlanDetailsData?.talkTime && (
              <div className="info-group">
                <label>Talk Time</label>
                <p className="font-weight-bold">
                  ₹ {rechargePlanDetailsData?.talkTime}
                </p>
              </div>
            )
          }
          {rechargePlanDetailsData?.data && (
            <div className="info-group">
              <label>Data</label>
              <p className="font-weight-bold">{rechargePlanDetailsData?.data}</p>
            </div>
          )}
          {
            rechargePlanDetailsData?.validity && (
              <div className="info-group">
                <label>Validity</label>
                <p className="font-weight-bold">
                  {rechargePlanDetailsData?.validity}
                </p>
              </div>
            )
          }
        </div>
        <div className="d-flex justify-content-start align-item-flex-start summary-card grid-3">
          {
            rechargePlanDetailsData?.calls && (
              <div className="info-group">
                <label>Calls</label>
                <p className="font-weight-bold">
                  {rechargePlanDetailsData?.calls}
                </p>
              </div>
            )
          }
          {rechargePlanDetailsData?.sms && (
            <div className="info-group">
              <label>SMS</label>
              <p className="font-weight-bold">{rechargePlanDetailsData?.sms}</p>
            </div>
          )}
          {
            rechargePlanDetailsData?.planName && (
              <div className="info-group">
                <label>Plan Name</label>
                <p className="font-weight-bold">{rechargePlanDetailsData?.planName}</p>
              </div>
            )
          }
        </div>
        {
          rechargePlanDetailsData?.validityDescription && (
            <div className="d-flex justify-content-between align-item-flex-start">
              <div className="info-group">
                <label>Validity Description:</label>
                <p className="font-weight-bold">
                  {rechargePlanDetailsData?.validityDescription}
                </p>
              </div>
            </div>
          )
        }
        {
          rechargePlanDetailsData?.packageDescription && (
            <div className="d-flex justify-content-between align-item-flex-start">
              <div className="info-group">
                <label>Details:</label>
                <p className="font-weight-bold">
                  {rechargePlanDetailsData?.packageDescription}
                </p>
              </div>
            </div>
          )
        }
        <div className="info-group dashed-border-top">
          <label> Bill amount </label>
          <h1 className="font_600"> ₹ {rechargePlanDetailsData?.price> 0 ?rechargePlanDetailsData?.price: 0 }</h1>
        </div>
      </div>
      {false && (
        <div className="d-flex justify-content-between align-items-center py-2">
          {/* <p>
            <SwitchButton
              label="Enable auto pay"
              name="autoPay"
              value={autoPay}
              onChange={handleSwitchButtonChange}
            />
          </p> */}
          <p>
            <SwitchButton
              label="Set Reminder"
              name="reminder"
              value={reminder}
              onChange={handleSwitchButtonChange}
            />
          </p>
        </div>
      )}
      {/* {billDetails && autoPay && <EnableAutoPay />} */}
      {reminder && <SetReminder />}
      <div className="my-2">
        {/* TODO: Bind Payment fun. by HARI */}
        <Button
          disabled={isLoading || !(rechargePlanDetailsData?.price > 0)}
          className="button btn-primary mb-4"
          onClick={() => {setIsLoading(true); preparePayment();}}
        >
          Pay Now
        </Button>
        <Button
          className="button btn-primary-outline"
          onClick={() => {
            if(saveButtonVisible && !isInVaildShortName  && rechargePlanDetailsData?.billNickName !== nickName.current.value){
              updateNickName({
                url: `${ADD_SHORT_NAME}${billDetails?.id}/link?billNickName=${nickName.current.value}`,
                token: authToken,
                data: {
                }
              });
              isRedirectToHomePage = true;
              setSaveButtonVisible(false);
            }
            else{
              history.push("/home");
            }
          }}
        >
          Done
        </Button>
      </div>
      {customPaymentLink === "" && (<form className="d-none" action={PAYU_URL} method="post" id="payUForm">
        <input
          type="hidden"
          name="firstname"
          value={prePaymentData?.firstname}
        />
        <input type="hidden" name="lastname" value={prePaymentData?.lastname} />
        <input type="hidden" name="surl" value={prePaymentData?.surl} />
        <input type="hidden" name="phone" value={prePaymentData?.phone} />
        <input type="hidden" name="key" value={prePaymentData?.key} />
        <input type="hidden" name="hash" value={prePaymentData?.hash} />
        <input type="hidden" name="curl" value={prePaymentData?.curl} />
        <input type="hidden" name="furl" value={prePaymentData?.furl} />
        <input type="hidden" name="txnid" value={prePaymentData?.txnid} />
        <input
          type="hidden"
          name="productinfo"
          value={prePaymentData?.productinfo}
        />
        <input type="hidden" name="amount" value={prePaymentData?.amt} />
        <input type="hidden" name="email" value={prePaymentData?.email} />
        <button className="d-none" type="submit" ref={submitButton}>
          submit
        </button>
      </form>)}

      {customPaymentLink !== "" && (
          <form
            className="d-none"
            action={customPaymentLink}
            method="post"
            id="payUForm"
          >
            {/* {prePaymentData &&
              Object.entries(prePaymentData).map(([key, value]) => {
                return customPaymentProps.indexOf(key) !== -1 ? (
                  <input key={key} type="hidden" name={key} value={value} />
                ) : (
                  ""
                );
              })}
            <input type="hidden" name="amount" value={prePaymentData?.amt} />
            <input
              type="hidden"
              name="custId"
              value={localStorage.getItem("SSO_CLIENT_ID")}
            />
            <input type="hidden" name="autopayment" value="No" />
            <input
              type="hidden"
              name="token"
              value={localStorage.getItem("SSO_CLIENT_TOKEN")}
            />

            <input
              type="hidden"
              name="txndate"
              // value={new Date().toISOString()}
              value="12 Jan 2022 5:15 PM"
            /> */}

          {prePaymentData && <input
              key="encDhanData"
              type="hidden"
              name="encDhanData"
              value={prePaymentData.encDhanData}
            />}

            <button className="d-none" type="submit" ref={submitButton}>
              Submit
            </button>
          </form>
        )}</>
      }
      {
        billErrorDetails && 
        <div className="d-flex flex-column">
          <p> { billErrorDetails?.message ?? `Invalid mobile number {mno}` }</p>
          <button
            className="button btn-primary-outline p-2 mt-2"
            onClick={() => history.push('/recharge/MOBILE%20PREPAID')}> Back to Mobile rechare page</button>
        </div>
      }
    </>
  );
}

export default RechargeSummary;
